export const SUB_CUSTOMER_FIELDS = {
  ID: 'id',
  DOCUMENT_ID: 'documentId',
  NAME: 'name',
  PHONE: 'phone',
  CODE: 'code',
} as const

export const T_KEYS = {
  SUB_CUSTOMERS: {
    TITLE: 'subCustomers.title',
    SUBTITLE: 'subCustomers.subtitle',
    ADD: 'subCustomers.addSubCustomer',
    EDIT: 'subCustomers.editSubCustomer',
    DELETE: 'subCustomers.deleteSubCustomer',
    SEARCH: 'subCustomers.search',
    NO_RESULTS: 'subCustomers.noResults',
    CODE: 'subCustomers.code',
    NAME: 'subCustomers.name',
    PHONE: 'subCustomers.phone',
    FORM: {
      NAME_PLACEHOLDER: 'subCustomers.form.namePlaceholder',
      PHONE_PLACEHOLDER: 'subCustomers.form.phonePlaceholder',
      NAME_REQUIRED: 'subCustomers.form.nameRequired',
    },
    MESSAGES: {
      CREATE_SUCCESS: 'subCustomers.messages.createSuccess',
      UPDATE_SUCCESS: 'subCustomers.messages.updateSuccess',
      DELETE_SUCCESS: 'subCustomers.messages.deleteSuccess',
    },
  },
} as const

export const API_ENDPOINTS = {
  LIST: '/api/sub-customers',
  DETAIL: (id: string) => `/api/sub-customers/${id}`,
} as const
